export const GETSUPPLIERS = "GETSUPPLIERS"
export const GETMYSUPPLIERS = "GETMYSUPPLIERS"
export const GETMYRECIVEDSUPPLIER = "GETMYRECIVEDSUPPLIER"